import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DeviceBasic } from 'src/app/models/device-models/device-basic-model/device-basic.model';
import { Subscription } from 'rxjs';
import { DepartmentsHelpbuttonService } from 'src/app/services/helpbutton-services/departments-helpbutton-service/departments-helpbutton.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-helpbutton-department-devices-card',
  templateUrl: './helpbutton-department-devices-card.component.html',
  styleUrls: ['./helpbutton-department-devices-card.component.scss']
})
export class HelpbuttonDepartmentDevicesCardComponent implements OnInit, OnDestroy {

  @Input() internalId;
  @Input() devices: Array<DeviceBasic>;
  @Input() assignedDevices: Array<DeviceBasic>;
  devicesInternalIdSubscription: Subscription;

  constructor(private departmentsService: DepartmentsHelpbuttonService,
              private snackbarService: SnackBarService) { }

  ngOnInit() { }

  public outputEventReceiver(selectedDevices) {
    const devicesInternalId = new Array();
    for (const d of selectedDevices) {
      devicesInternalId.push(d[1]._data);
    }
    this.devicesInternalIdSubscription = this.departmentsService.saveDepartmentDevices(this.internalId, devicesInternalId).subscribe(
      (res) => {
        // this.departmentsService.refreshDepartment();
      },
      (error) => {
        this.departmentsService.refreshDepartment();
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  ngOnDestroy() {
    if (this.devicesInternalIdSubscription) { this.devicesInternalIdSubscription.unsubscribe(); }
  }
}
